import React from 'react';
import InputRange from 'react-input-range';
import './Slider.scss';

interface Props {
	value: number;
	onChange: (x: number) => void;
	onChangeCompleteHandler: () => void;
}

const Slider = ({
	value,
	onChange,
	onChangeCompleteHandler
}: Props): JSX.Element => {
	return (
		<div className="slider-wrapper">
			<InputRange
				maxValue={3000}
				minValue={0}
				value={value}
				onChange={onChange}
				onChangeComplete={onChangeCompleteHandler}
			/>
		</div>
	);
};

export default Slider;
